import { defineMessages } from 'react-intl';
import { EMAIL_REGEX } from 'constants/regexes';
import { deepExtract } from 'helpers/deep';
import { isBlank, isEmpty } from 'helpers/verify';
var messages = defineMessages({
  invalidLocation: {
    id: 'sell.validations.invalidLocation',
    defaultMessage: 'Oops! Please provide a valid location.'
  },
  invalidEmail: {
    id: 'sell.validations.invalidEmail',
    defaultMessage: 'Oops! Please provide a valid email.'
  }
});
export var Validator = function Validator(data) {
  var errors = {};

  if (isEmpty(deepExtract('location', data))) {
    errors.location = messages.invalidLocation;
  }

  if (isBlank(data.email) || !EMAIL_REGEX.test(data.email)) {
    errors.email = messages.invalidEmail;
  }

  return errors;
};
export var HeroValidator = function HeroValidator(data) {
  var errors = {};

  if (isBlank(data.email) || !EMAIL_REGEX.test(data.email)) {
    errors.email = messages.invalidEmail;
  }

  return errors;
};